import { createTheme } from "@mui/material/styles";

const fontLato = ["Lato", "sans-serif"].join(', ');

const Theme = createTheme({
    palette:{
        primary:{
            main: '#0f172a',    // Slate 900 - deep navy
            light: '#1e293b',   // Slate 800
            dark: '#020617',    // Slate 950
        },
        secondary: {
            light: '#f1f5f9',   // Slate 100
            main: '#3b82f6',    // Blue 500 - modern accent
            dark: '#1d4ed8',    // Blue 700
        },
        background: {
            default: '#f8fafc', // Slate 50
            paper: '#ffffff'
        },
        text: {
            primary: '#0f172a',
            secondary: '#475569'
        }
    },
    typography: {
        fontFamily: fontLato,
        title: {
            fontFamily: fontLato,
            fontWeight: 900,
            fontSize: '3rem',
            letterSpacing: '-0.02em',
            lineHeight: 1.1,
        },
        h1:{
            fontFamily: fontLato,
            fontWeight: 800,
            fontSize: '3.5rem',
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
        },
        h2:{
            fontFamily: fontLato,
            fontWeight: 700,
            fontSize: '2.25rem',
            letterSpacing: '-0.01em',
            lineHeight: 1.3,
        },
        h3:{
            fontFamily: fontLato,
            fontWeight: 600,
            fontSize: '1.5rem',
            lineHeight: 1.4,
        },
        navButton:{
            fontFamily: fontLato,
            fontWeight: 500,
            fontSize: '0.95rem',
            letterSpacing: '0.01em',
        },
        body:{
            fontFamily: fontLato,
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: 1.7,
            color: '#475569'
        },
        note:{
            fontFamily: fontLato,
            fontWeight: 400,
            fontSize: '0.875rem',
            color: '#64748b'
        },
    },
    shadows: [
        'none',
        '0 1px 2px rgba(0,0,0,0.05)',
        '0 4px 6px rgba(0,0,0,0.07)',
        '0 10px 15px rgba(0,0,0,0.1)',
        '0 20px 25px rgba(0,0,0,0.1)',
        ...Array(20).fill('none')
    ],
    components: {
        MuiButton:{
            defaultProps:{
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease'
                }
            },
            variants: [
                {
                    props: {variant: 'navigation-button'},
                    style: {
                        color: '#475569',
                        fontWeight: 500,
                        padding: '0.5rem 1rem',
                        '&:hover': {
                            color: '#3b82f6',
                            backgroundColor: 'rgba(59, 130, 246, 0.08)'
                        }
                    }
                },
            ]
        },
    },
});

export default Theme;